import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5543991045996', '_blank');
  };

  return (
    <section id="home" className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight" style={{ color: '#193B7F' }}>
              {t.hero.title}
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
              {t.hero.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={handleWhatsAppClick}
                size="lg"
                className="group text-white hover:shadow-lg transition-all duration-300"
                style={{ backgroundColor: '#193B7F' }}
              >
                {t.hero.cta}
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
              </Button>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1529119368496-2dfda6ec2804?w=800&q=80"
                alt="Business consulting"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#193B7F]/20 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div
              className="absolute -bottom-6 -right-6 w-64 h-64 rounded-full blur-3xl opacity-20"
              style={{ backgroundColor: '#45C1E0' }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
